export default function isNumber(val: string) {
    return !(/[a-zA-Z]|[а-яА-Я]/.test(val))
}